var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195 96.2307C195 96.8674 194.99 97.5017 194.969 98.1333C203.917 103.005 210 112.58 210 123.596C210 137.479 200.336 149.074 187.454 151.849L196.385 135.194C197.867 132.727 196.09 129.586 193.211 129.586H192.603H183.598C182.898 129.586 182.415 128.887 182.662 128.233L189.85 109.183L189.994 108.813C191.017 106.19 189.082 103.36 186.267 103.36H185.636H155.271H154.855C153.059 103.36 151.483 104.556 151.001 106.286L150.925 106.56L138.554 150.962L138.131 152.481L69 152.481C47.4609 152.481 30 134.784 30 112.954C30 91.1235 47.4609 73.4266 69 73.4266C75.4999 73.4266 81.6283 75.0382 87.0176 77.8886C94.5218 55.8284 115.185 39.9807 139.5 39.9807C170.152 39.9807 195 65.1647 195 96.2307Z",
    fill: "#A3B6C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.73 109.283C156.825 109.283 156.033 109.891 155.798 110.764L145.288 149.911C144.947 151.182 145.904 152.43 147.219 152.43H161.329C162.522 152.43 163.45 153.468 163.316 154.654L159.541 188.058C159.291 190.271 162.3 191.175 163.311 189.191L189.572 137.625C190.249 136.295 189.283 134.718 187.79 134.718H176.256C174.837 134.718 173.87 133.282 174.402 131.968L182.464 112.033C182.996 110.718 182.028 109.283 180.61 109.283H157.73Z",
    fill: "#FFB930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningLm);
export default __webpack_public_path__ + "static/media/lightning-lm.c92e4f72e0d600b41ea037fba5cec474.svg";
export { ForwardRef as ReactComponent };